<ul class="nav nav-tabs">
    <li class="nav-item" style="cursor: pointer;" aria-label="Tabs" *ngFor="let tab of tabs">
        <a class="nav-link" [class.active]="tab.active" (click)="activateTab(tab)">
            {{ tab.heading }}
        </a>
    </li>
</ul>

<ng-container *ngFor="let tab of tabs">
    <ng-container *ngIf="tab.active">
        <ng-container *ngTemplateOutlet="tab.template"></ng-container>
    </ng-container>
</ng-container>